import $ from 'jquery';
import _, { has } from 'underscore';
import Numeral from 'numeral';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import Config from 'root/config';
import Form from 'root/module/form';
import Tooltip from 'root/module/tooltip';
import Button from 'root/module/button';
import View from 'view/base';

export default View.extend({
    className: 'account-upgrade-payment',

    billing_interval: Constants.MONTHLY,
    plan_type: Constants.PLAN_2022_COMPANY,

    extra_user: 0,
    session_limit: 0,

    is_upgrade: false,

    events: {
        'click .billing-cycle-selection > span' : 'selectBillingCycle',
        'keyup input[name="number"]'            : 'checkCreditCardType',
        'c:input input[name="user-limit"]'      : 'changeUserLimit',
        'click .addon-toggle'                   : 'toggleAddon',
        'click .dropdown-session-limit li'      : 'selectSessionLimit',
        'click a.go-back'                       : 'goBack',
        'submit form.payment'                   : 'submit',
        'click .submit-free'                    : 'submitFree',
        'click .change-plan'                    : 'changePlan'
    },

    dom_handlers: {
        selectBillingCycle: function(e) {
            if ($(e.currentTarget).hasClass('active')) {
                return;
            }

            if (this.billing_interval === Constants.MONTHLY) {
                this.billing_interval = Constants.ANNUALLY;

                this.$el.find('.billing-cycle-selection > span:first').removeClass('active');
                this.$el.find('.billing-cycle-selection > span:last').addClass('active');
            } else {
                this.billing_interval = Constants.MONTHLY;

                this.$el.find('.billing-cycle-selection > span:first').addClass('active');
                this.$el.find('.billing-cycle-selection > span:last').removeClass('active');
            }

            this.updatePrice();
        },

        changeUserLimit: function(e) {
            this.extra_user = parseInt($(e.currentTarget).val(), 10);

            this.updatePrice();
            this.updateFeatrueLoss();
        },

        toggleAddon: function(e) {
            var has_portal = this.$el.find('.addon-toggle').hasClass('switch-off');

            if (has_portal) {
                this.$el.find('.addon-toggle').removeClass('switch-off').addClass('switch-on');
            } else {
                this.$el.find('.addon-toggle').removeClass('switch-on').addClass('switch-off');
            }

            this.updatePrice();
            this.updateFeatrueLoss();
        },

        checkCreditCardType: function(e) {
            var cc_number = $(e.currentTarget).val().replace(/ /g, '');
            var cc_type   = Util.getCreditCardType(cc_number);

            switch (cc_type) {
                case 'Visa':
                    this.$el.find('.cc-icons').html('<i class="fab fa-cc-visa active"></i>');
                    break;
                case 'Mastercard':
                    this.$el.find('.cc-icons').html('<i class="fab fa-cc-mastercard active"></i>');
                    break;
                case 'AMEX':
                    this.$el.find('.cc-icons').html('<i class="fab fa-cc-amex active"></i>');
                    break;
                case 'Discover':
                    this.$el.find('.cc-icons').html('<i class="fab fa-cc-discover active"></i>');
                    break;
                case 'Diners':
                    this.$el.find('.cc-icons').html('<i class="fab fa-cc-diners-club active"></i>');
                    break;
                case 'JCB':
                    this.$el.find('.cc-icons').html('<i class="fab fa-cc-jcb active"></i>');
                    break;
                default:
                    this.$el.find('.cc-icons').html('<i class="fas fa-credit-card-front"></i>');
            }
        },

        selectSessionLimit: function(e) {
            this.session_limit = parseInt($(e.currentTarget).data('val'), 10);
            this.updatePrice();
        },

        goBack: function(e) {
            e.preventDefault();

            this.trigger('back', {
                billing_interval : this.billing_interval,
                plan_type        : this.plan_type
            });
        },

        // upgrade from trial to paid
        submit: function(e) {
            e.preventDefault();

            if (this.$el.find('.account-payment-submit').hasClass('success')) {
                return;
            }

            if (typeof Stripe === 'undefined') {
                UI.error('Failed to load Stripe payment. Please refresh the page and try again.');
                return;
            }

            var credit_card_form = this.$el.find('form.payment');

            credit_card_form.find('.account-payment-submit').addClass('loading').prop('disabled', true);
            credit_card_form.find('i.text-danger').hide();
            credit_card_form.find('input.invalid').removeClass('invalid');

            Tooltip.removeAll();

            var form_data = Form.getData(credit_card_form);
            form_data.number = form_data.number.toString().replace(/ /g, '');

            var exp_month = 0;
            var exp_year  = 0;

            if (form_data.expiry.toString().split('/').length === 2) {
                exp_month = form_data.expiry.toString().split('/')[0].trim();
                exp_year  = form_data.expiry.toString().split('/')[1].trim();
            }

            Stripe.setPublishableKey(Cache.app.configs.stripe_publishable_key);
            Stripe.card.createToken({
                number    : form_data.number,
                exp_month : exp_month,
                exp_year  : exp_year,
                cvc       : form_data.cvc
            }, (status, response) => {
                if (status == 200) {
                    if (!response.id) {
                        UI.error('Credit card token failed to create. Please refresh and try again.');
                    }

                    Cache.app.request({
                        action: 'account/upgrade',
                        data : {
                            source            : response.id,
                            plan              : this.plan_type,
                            has_portal        : this.$el.find('.addon-toggle').hasClass('switch-on'),
                            billing_interval  : this.billing_interval,
                            extra_user        : this.extra_user,
                            session_limit     : this.session_limit,
                            country           : form_data.country,
                            name              : form_data.name,
                            credit_card_digit : form_data.number.slice(form_data.number.length - 4, form_data.number.length)
                        },
                        success: function(response) {
                            if (response !== true) {
                                var error_message = response && response.error ? response.error : 'Credit Card declined, please check your Credit Card details and try again.';
                                UI.error(error_message);
                                return;
                            }

                            credit_card_form.find('.account-payment-submit')
                                .prop('disabled', false)
                                .removeClass('primary loading')
                                .addClass('success')
                                .html('<i class="fad fa-thumbs-up pulse animated"></i>');

                                // Rewardful tracking
                                if (typeof rewardful === 'function') {
                                    rewardful('convert', {
                                        email: Cache.getRealUser().get('email')
                                    });
                                }

                                setTimeout(function() {
                                    if (Cache.app.isAdmin()) {
                                        Util.windowParent().location = '/account/billing?msg=Your account has been upgraded.';
                                    } else {
                                        Util.windowParent().location = '/dashboard/billing?msg=Your account has been upgraded.';
                                    }
                                }, 1000);
                        },
                        complete: function() {
                            credit_card_form.find('.account-payment-submit').removeClass('loading').prop('disabled', false);
                        }
                    });
                } else {
                    if (response.error) {
                        credit_card_form.find('button').removeClass('loading').prop('disabled', false);

                        switch (response.error.param) {
                            case 'number':
                                credit_card_form.find('input[name="number"]').addClass('invalid').select();
                                credit_card_form.find('input[name="number"]').prev('div').children('i').data('title', response.error.message).show().trigger('mouseenter');
                                break;
                            case 'exp_month':
                            case 'exp_year':
                                credit_card_form.find('input[name="expiry"]').addClass('invalid').select();
                                credit_card_form.find('input[name="expiry"]').prev('div').children('i').data('title', response.error.message).show().trigger('mouseenter');
                                break;
                            case 'cvc':
                                credit_card_form.find('input[name="cvc"]').addClass('invalid').select();
                                credit_card_form.find('input[name="cvc"]').prev('div').children('i').data('title', response.error.message).show().trigger('mouseenter');
                                break;
                        }

                        if (response.error.code) {
                            switch (response.error.code) {
                                case 'card_declined':
                                    UI.error('Credit Card declined, please check your Credit Card details and try again.');
                                    break;
                                case 'incorrect_cvc':
                                    UI.error('Incorrect CVC, please check your Credit Card details and try again.');
                                    break;
                                case 'expired_card':
                                    UI.error('Credit Card expired, please check your Credit Card details and try again.');
                                    break;
                                case 'processing_error':
                                    UI.error('Processing error, please check your Credit Card details and try again.');
                                    break;
                            }
                        }
                    } else {
                        UI.error('Credit card token failed to create. Please refresh and try again.');
                    }
                }
            });

            // tracking
            if (!Cache.app.debug) {
                try {
                    var upgrade_value = this.$el.find('input[name="gtm_upgrade_value"]').val() || 0;

                    // GA4 event
                    if (typeof dataLayer === 'object') {
                        dataLayer.push({
                            'event': 'successful_upgrade'
                        });
                    }

                    // Google Ads
                    if (typeof gtag === 'function') {
                        gtag('event', 'conversion', {
                            send_to  : 'AW-871130930/UeiVCNb6gfkBELLOsZ8D',
                            value    : upgrade_value,
                            currency : 'USD'
                        });
                    }

                    // Facebook
                    if (typeof fbq === 'function') {
                        fbq('track', 'Purchase', {
                            currency : 'USD',
                            value    : upgrade_value
                        });
                    }

                    // LinkedIn
                    if (typeof lintrk === 'function') {
                        // Conversion name:  Trial Upgrade
                        window.lintrk('track', {
                            conversion_id: 14439348,
                            conversion_value: upgrade_value
                        });
                    }
                } catch (e) {
                }
            }

            Cache.app.trackEvent('Upgrade', {
                value: upgrade_value,
                plan_name: Cache.account.getPlanName(this.plan_type),
                session_limit: this.session_limit
            });
        },

        // upgrade from trial to free
        submitFree: function(e) {
            this.$el.find('.submit-free').addClass('loading').prop('disabled', true);

            if (this.is_upgrade) {
                // upgrade from trial to free
                Cache.app.request({
                    action: 'account/upgrade',
                    data : {
                        plan             : Constants.PLAN_2025_FREE,
                        billing_interval : Constants.MONTHLY
                    },
                    success: () => {
                        // TODO: tracking
                        if (Cache.app.isAdmin()) {
                            Util.windowParent().location = '/account/billing?msg=Your account has been upgraded.';
                        } else {
                            Util.windowParent().location = '/dashboard/billing?msg=Your account has been upgraded.';
                        }
                    }
                });
            } else {
                // change from a paid plan to free
                Cache.app.request({
                    action: 'account/changePlan',
                    data: {
                        plan             : Constants.PLAN_2025_FREE,
                        billing_interval : Constants.MONTHLY
                    },
                    success: (response) => {
                        // TODO: tracking

                        Util.windowParent().location = '/account/billing?msg=Your subscription has been updated.';
                    }
                });
            }
        },

        // change plan
        changePlan: function(e) {
            this.$el.find('button.change-plan').addClass('loading').prop('disabled', true);

            var has_portal = this.$el.find('.addon-toggle').hasClass('switch-on');

            Cache.app.request({
                action: 'account/changePlan',
                data: {
                    billing_interval : this.billing_interval,
                    plan             : this.plan_type,
                    extra_user       : this.extra_user,
                    session_limit    : this.session_limit,
                    has_portal       : has_portal
                },
                success: (response) => {
                    this.$el.find('button.change-plan')
                        .prop('disabled', false)
                        .removeClass('primary loading')
                        .addClass('success')
                        .html('<i class="fad fa-thumbs-up pulse animated"></i>');

                    Cache.app.trackEvent('Change Plan', {
                        plan_name: Cache.account.getPlanName(this.plan_type),
                        session_limit: this.session_limit,
                        user_limit: this.extra_user,
                        addon: has_portal ? 'portal' : ''
                    });

                    setTimeout(() => {
                        Util.windowParent().location = '/account/billing?msg=Your subscription has been updated.';
                    }, 1000);
                },
                complete: () => {
                    this.$el.find('button.change-plan').removeClass('loading').prop('disabled', false);
                }
            });
        }
    },

    updatePrice: function() {
        // summary
        var total_price = 0;
        var credit = 0;
        var cost = 0;
        var has_portal = this.$el.find('.addon-toggle').hasClass('switch-on');
        var addons = has_portal ? ['portal'] : [];

        var user_fee         = Cache.account.getPrice(this.plan_type, this.billing_interval, 0, this.extra_user, 0);
        var session_fee      = Cache.account.getSessionPrice(this.plan_type, this.session_limit, this.billing_interval);
        var addon_fee        = has_portal ? Cache.account.getAddonPrice(this.plan_type, this.billing_interval, 'portal') : 0;
        var subscription_fee = Cache.account.getPrice(this.plan_type, this.billing_interval, 0, this.extra_user, this.session_limit, 0, addons);

        if (this.isReferredUpgrade()) {
            if (this.billing_interval === Constants.ANNUALLY) {
                total_price = subscription_fee * 11 + 1;
                cost = subscription_fee * 12;
            } else {
                total_price = 1;
                cost = subscription_fee;
            }

            credit = subscription_fee - 1;
        } else {
            total_price = subscription_fee;

            if (this.billing_interval === Constants.ANNUALLY) {
                total_price = total_price * 12;
            }

            cost = total_price;

            if (this.isPromoCodeUpgrade()) {
                if (Cache.account.get('discount_plan_type') === 0 || Cache.account.get('discount_plan_type') === this.billing_interval) {
                    credit = Math.ceil(cost * Cache.account.get('discount') * 0.01);
                    credit = Math.min(credit, cost - 1); // pay at least $1
                    total_price = total_price - credit;
                }
            }
        }

        // plan summary
        this.$el.find('.price-user-count').text(Numeral(this.extra_user).format('0,0'));
        this.$el.find('.price-session-count').text(Numeral(this.session_limit).format('0,0'));
        this.$el.find('.plan-summary-old').html(Cache.account.getPlanName(Cache.account.get('plan')) + (Cache.account.get('is_trial') ? ' (Trial)' : ''));
        this.$el.find('.plan-summary-new').html(Cache.account.getPlanName(this.plan_type));
        this.$el.find('.user-summary-cost').text(user_fee.toFixed(2));
        this.$el.find('.session-summary-cost').text(session_fee.toFixed(2));
        this.$el.find('.addon-summary-cost').text(addon_fee.toFixed(2));
        this.$el.find('.price-item-session').toggle(session_fee > 0);
        this.$el.find('.price-item-addon').toggle(addon_fee > 0);

        total_price = total_price.toFixed(2);

        if (cost % 1 !== 0) {
            cost = cost.toFixed(2);
        }

        if (credit % 1 !== 0) {
            credit = credit.toFixed(2);
        }

        this.$el.find('.account-upgrade-summary .price-cost').text(cost);
        this.$el.find('.account-upgrade-summary .price-credit').text(credit);
        this.$el.find('.account-upgrade-summary .price-total').text(total_price);
        this.$el.find('.account-upgrade-summary .price-total-unit').text(this.billing_interval === Constants.ANNUALLY ? '/year' : '/month');

        // update plan
        var discount = 0;
        if (this.isPromoCodeChangePlan()) {
            if (Cache.account.get('discount_plan_type') === 0 || Cache.account.get('discount_plan_type') === this.billing_interval) {
                discount = Cache.account.get('discount');
            }
        }
        this.$el.find('.account-upgrade-summary .price-discount').text(discount + '%');

        // GTM
        this.$el.find('input[name="gtm_upgrade_value"]').val(total_price);

        if (this.is_upgrade) {
            this.$el.find('.account-payment-submit').prop('disabled', total_price <= 0);
        } else {
            var submit_button = this.$el.find('.change-plan');
            var has_user_limit_changed = this.extra_user !== Cache.account.get('extra_user');
            var has_sessions_limit_changed  = this.session_limit  !== Cache.account.get('session_limit');
            var has_addon_changed = has_portal !== Cache.account.hasAddon('portal');

            if (this.plan_type !== Cache.account.get('plan') ||
                this.billing_interval !== Cache.account.get('billing_interval') ||
                has_user_limit_changed ||
                has_sessions_limit_changed ||
                has_addon_changed) {

                submit_button.prop('disabled', false);
            } else {
                submit_button.prop('disabled', true);
            }

            if (Cache.account.get('billing_interval') === Constants.ANNUALLY && !Cache.account.get('last_billing_month')) {
                // allow annually to monthly with no plan change
                if (this.billing_interval === Constants.MONTHLY) {
                    if (this.plan_type !== Cache.account.get('plan')) {
                        submit_button.prop('disabled', true);
                    }
                } else {
                    if (this.plan_type < Cache.account.get('plan')) {
                        submit_button.prop('disabled', true);
                    }
                }
            }
        }
    },

    updateFeatrueLoss: function() {
        var feature_loss = this.getFeatureLoss();

        if (feature_loss.length && !this.is_upgrade) {
            this.$el.find('.region-feature-loss').html(
                '<div class="box-neutral margin-top-24">' +
                    '<div class="font-weight-semibold">Things you will lose:</div>' +
                    '<ul class="feature-loss">' +
                        this.getFeatureLoss().map((feature) => {
                            return '<li>' + feature + '</li>';
                        }).join('') +
                    '</ul>' +
                '</div>'
            );
        } else {
            this.$el.find('.region-feature-loss').html('');
        }
    },

    initialize: function(options) {
        this.is_upgrade = Cache.account.get('is_trial') || Cache.account.get('is_expired') || Cache.account.isFreePlan();

        this.billing_interval = options.billing_interval;
        this.plan_type        = options.plan_type;
        this.extra_user       = options.extra_user;
        this.session_limit    = options.session_limit;

        if (this.plan_type === Constants.PLAN_2025_FREE) {
            this.billing_interval = Constants.MONTHLY;
        }

        // validation
        if (Cache.account.getSessionLimitOptions(this.plan_type).indexOf(this.session_limit) === -1) {
            this.session_limit = 0;
        }

        if (typeof Stripe === 'undefined') {
            var script = document.createElement('script');
            script.src = 'https://js.stripe.com/v2/';
            document.head.appendChild(script);
        }
    },

    isReferredUpgrade: function() {
        return this.is_upgrade && Cache.account.get('referred_by') > 0 && Cache.account.get('is_trial');
    },

    isPromoCodeUpgrade: function() {
        return this.is_upgrade && Cache.account.get('discount') > 0;
    },

    isPromoCodeChangePlan: function() {
        return !this.is_upgrade && Cache.account.get('discount') > 0;
    },

    hasOnePremiumPlan: function() {
        if (Cache.account.get('premium_monthly_price') && Cache.account.get('premium_annual_price')) {
            return false;
        } else if (Cache.account.get('premium_monthly_price')) {
            return true;
        } else if (Cache.account.get('premium_annual_price')) {
            return true;
        }
    },

    getFeatureLoss: function() {
        var features = {
            [Constants.PLAN_2025_BUSINESS_PLUS]: ['Account branding', 'Remove Userback logo', 'SSO', 'Rest API Access', 'Webhooks', 'Data masking', 'Email Forwarding'],
            [Constants.PLAN_2025_BUSINESS]: ['AI Assist', 'Feedback automation tools', 'Developer tools', 'Reply templates', 'Session replays', 'User segments', 'JavaScript SDK']
        };

        var plan_before = Cache.account.get('plan');
        var plan_after  = this.plan_type;

        var project_total = Cache.project.where({is_archived: false}).length;
        var project_limit = Cache.account.getProjectLimit(this.plan_type);

        var user_total = Cache.workspace_member.where({is_disabled: false}).length;
        var user_limit = this.extra_user;

        var has_portal = this.$el.find('.addon-toggle').hasClass('switch-on');

        var feature_loss = [];

        if (Cache.account.hasUserLimit(plan_after) && user_limit < user_total) {
            feature_loss.push((user_total - user_limit) + ' Team member' + (user_total - user_limit === 1 ? '' : 's'));
        }

        if (project_limit < project_total) {
            feature_loss.push((project_total - project_limit) + ' Project' + (project_total - project_limit === 1 ? '' : 's'));
        }

        if (plan_after === Constants.PLAN_2025_FREE) {
            feature_loss.push('Unlimited feedback & retention');
        }

        if (!has_portal && Cache.account.hasAddon('portal')) {
            feature_loss.push('Ideas portal');
        }

        if (plan_before <= plan_after || plan_after === Constants.PLAN_2025_CUSTOM) {
            // upgrade or custom plan
        } else {
            // downgrade
            if (plan_after === Constants.PLAN_2025_BUSINESS) {
                feature_loss = feature_loss.concat(features[Constants.PLAN_2025_BUSINESS_PLUS]);
            } else if (plan_after === Constants.PLAN_2025_TEAM || plan_after === Constants.PLAN_2025_FREE) {
                feature_loss = feature_loss.concat(features[Constants.PLAN_2025_BUSINESS]).concat(features[Constants.PLAN_2025_BUSINESS_PLUS]);
            }
        }

        return feature_loss;
    },

    render: function() {
        var content = '';

        var discount_plan_type = '';

        if (Cache.account.get('discount_plan_type') === Constants.MONTHLY) {
            discount_plan_type = '<div class="cap">(Monthly plan only)</div>';
        } else if (Cache.account.get('discount_plan_type') === Constants.ANNUALLY) {
            discount_plan_type = '<div class="cap">(Annual plan only)</div>';
        }

        var country_list = '<option value="">Select...</option>';
        _.each(Config.country_list, function(country, value) {
            country_list += '<option value="' + value +  '">' + country + '</option>';
        });

        var session_limit_options = '';
        Cache.account.getSessionLimitOptions(this.plan_type).forEach((limit) => {
            session_limit_options += '<li data-val="' + limit + '"' + (this.session_limit === limit ? ' class="selected"' : '') + '>' + Numeral(limit).format('0,0') + '</li>';
        });

        content +=
        '<a class="go-back" href="#"><i class="fa-solid fa-angle-left margin-right-8 text-icon"></i>Choose Plan</a>' +
        '<div class="account-payment-main' + (this.plan_type === Constants.PLAN_2025_FREE ? ' account-payment-main-free' : '') + '">' +
            '<div>' +
                '<div class="account-upgrade-summary box">' +
                    '<h3 class="info">Summary</h3>' +
                    '<hr class="small">' +

                    (this.plan_type === Cache.account.get('plan') ?
                    '' :
                    '<div class="price-item">' +
                        '<span>Current Plan</span>' +
                        '<span class="plan-summary-old"></span>' +
                    '</div>') +

                    '<div class="price-item">' +
                        (this.plan_type === Cache.account.get('plan') ?
                        '<span>Plan</span>' :
                        '<span>New Plan</span>') +
                        '<span class="plan-summary-new"></span>' +
                    '</div>' +

                    (this.plan_type !== Constants.PLAN_2025_FREE && this.plan_type !== Constants.PLAN_2025_CUSTOM ?
                    '<div class="price-item price-item-seats">' +
                        '<span>Seat x <span class="price-user-count"></span></span>' +
                        '<span class="plan-cost">$<span class="user-summary-cost"></span>/<span class="plan-summary-unit">month</span></span>' +
                    '</div>' : '') +

                    (this.plan_type === Constants.PLAN_2025_BUSINESS_PLUS ?
                    '<div class="price-item price-item-session">' +
                        '<span>Session x <span class="price-session-count"></span></span>' +
                        '<span class="plan-cost">$<span class="session-summary-cost"></span>/<span class="plan-summary-unit">month</span></span>' +
                    '</div>' : '') +

                    '<div class="price-item price-item-addon">' +
                        '<span>Add-on: Ideas portal</span>' +
                        '<span class="plan-cost">$<span class="addon-summary-cost"></span>/<span class="plan-summary-unit">month</span></span>' +
                    '</div>' +

                    (this.isReferredUpgrade() ?
                    '<div class="price-item">' +
                        '<span>Referral Credit</span>' +
                        '<span>-$<span class="price-credit"></span></span>' +
                    '</div>' : '') +

                    (!this.isReferredUpgrade() && this.isPromoCodeUpgrade() ?
                    '<div class="price-item">' +
                        '<span>Discount</span>' +
                        '<span>-$<span class="price-credit"></span></span>' +
                    '</div>' +
                    '<div class="price-promo-code">' +
                        'Promo Code: <b>' + Cache.account.get('signup_code') + '</b>' +
                        discount_plan_type +
                    '</div>' : '') +

                    (this.isPromoCodeChangePlan() ?
                    '<div class="price">' +
                        '<b>Discount</b>' +
                        '<span><span class="price-discount"></span></span>' +
                    '</div>' +
                    '<div class="price-promo-code">' +
                        'Promo Code: <b>' + Cache.account.get('signup_code') + '</b>' +
                        discount_plan_type +
                    '</div>' : '') +

                    '<hr class="small">' +
                    '<div class="price">' +
                        '<span>Total Cost</span>' +
                        '<span>' +
                            '<span class="font-weight-bold text-xlarge">$<span class="price-total"></span></span>' +
                            '<span class="price-total-unit"></span>' +
                        '</span>' +
                    '</div>' +

                    (this.plan_type !== Constants.PLAN_2025_CUSTOM ?
                    '<div class="region-feature-loss"></div>' : '') +

                    (this.plan_type === Constants.PLAN_2025_FREE ?
                    '<button type="button" class="submit-free primary full margin-top-24">Update Subscription</button>' : '') +
                '</div>' +
            '</div>' +
            (this.plan_type === Constants.PLAN_2025_FREE ? '' :
            '<div>' +
                '<div class="box">' +
                    '<div class="account-upgrade-options">' +
                        '<div class="card-wrapper margin-bottom-40 hidden"></div>' +

                        '<h3 class="info">Options</h3>' +
                        '<hr class="small">' +

                        (this.plan_type === Constants.PLAN_2025_CUSTOM && (Cache.account.get('premium_monthly_price') === 0 || Cache.account.get('premium_annual_price') === 0) ? '' :
                        '<div class="plan-input margin-top-0">' +
                            '<span>Billing Cycle</span>' +
                            '<div>' +
                                '<div class="billing-cycle-selection badge-group-tertiary">' +
                                    '<span' + ((this.billing_interval === Constants.MONTHLY  ? ' class="active"' : '')) + '>Monthly</span>' +
                                    '<span' + ((this.billing_interval === Constants.ANNUALLY ? ' class="active"' : '')) + '>Yearly</span>' +
                                '</div>' +
                            '</div>' +
                        '</div>') +

                        '<div class="plan-input">' +
                            '<span>Seats</span>' +
                            (this.plan_type === Constants.PLAN_2025_CUSTOM ?
                            '<span>' + Cache.account.get('premium_user_limit') + '</span>' :
                            '<div class="number-input">' +
                                '<input type="text" name="user-limit" max="' + Cache.account.getUserMax(this.plan_type) + '" min="1" value="' + this.extra_user + '">' +
                                '<button class="number-input-minus" type="button"><i class="far fa-minus"></i></button>' +
                                '<button class="number-input-plus" type="button"><i class="far fa-plus"></i></button>' +
                            '</div>') +
                        '</div>' +

                        (this.plan_type === Constants.PLAN_2025_BUSINESS_PLUS ?
                        '<div class="plan-input">' +
                            '<span>Session Replays (per month)</span>' +
                            '<div class="button-dropdown button-dropdown-full" data-update="true">' +
                                '<button type="button" class="dropdown-select session-limit">' + Numeral(this.session_limit).format('0,0') + '</button>' +
                                '<div>' +
                                    '<ul class="dropdown dropdown-select dropdown-session-limit">' + session_limit_options + '</ul>' +
                                '</div>' +
                            '</div>' +
                        '</div>' : '') +

                        (this.plan_type === Constants.PLAN_2025_CUSTOM && Cache.account.get('premium_session_limit') ?
                        '<div class="plan-input">' +
                            '<span>Session Replays (per month)</span>' +
                            '<span>' + Numeral(Cache.account.get('premium_session_limit')).format(',') + '</span>' +
                        '</div>' : '') +

                        (this.plan_type !== Constants.PLAN_2025_CUSTOM ?
                        '<div class="font-weight-semibold">Add-ons:</div>' +

                        '<div class="plan-input margin-top-8">' +
                            '<span>Ideas portal</span>' +
                            '<div class="flex-start"><button class="addon-toggle small ' + (Cache.account.hasAddon('portal') && !this.is_upgrade ? 'switch-on' : 'switch-off') + '"></button></div>' +
                        '</div>' : '') +

                        // TODO: AI-addon for appsumo
                    '</div>' +
                    (this.is_upgrade ?
                    '<div class="account-upgrade-payment-form margin-top-32">' +
                        '<h3 class="info">Complete Payment</h3>' +
                        '<hr class="small">' +

                        '<form class="payment userback-block form-fluid" id="gtm_upgrade_form">' +
                            '<div class="row">' +
                                '<div class="field-label">Name on Card <i class="tooltip fas fa-circle-exclamation text-danger" style="display:none;"></i></div>' +
                                '<input type="text" class="solid medium" name="name" maxlength="255" placeholder="' + Cache.getRealUser().escape('name')  + '" required>' +
                            '</div>' +

                            '<div class="row grid-6-3-3 grid-gap-8">' +
                                '<div class="position-relative">' +
                                    '<div class="field-label">Credit Card Number <i class="tooltip fas fa-ecircle-exclamation text-danger" style="display:none;"></i></div>' +
                                    '<input type="text" class="solid medium" name="number" maxlength="30" placeholder="0000 0000 0000 0000" required>' +
                                    '<div class="cc-icons">' +
                                        '<i class="fas fa-credit-card-front"></i>' +
                                    '</div>' +
                                '</div>' +
                                '<div>' +
                                    '<div class="field-label">Expiry Date <i class="tooltip fas fa-circle-exclamation text-danger" style="display:none;"></i></div>' +
                                    '<input type="text" class="solid medium" name="expiry" maxlength="7" placeholder="MM/YY" required>' +
                                '</div>' +
                                '<div>' +
                                    '<div class="field-label">CVC <i class="tooltip fas fa-circle-exclamation text-danger" style="display:none;"></i></div>' +
                                    '<input type="text" class="solid medium" name="cvc" data-validation="string" maxlength="4" placeholder="3 or 4 digits" required>' +
                                '</div>' +
                            '</div>' +

                            '<div class="row">' +
                                '<div class="field-label">Country</div>' +
                                '<select name="country" class="solid medium" required>' + country_list + '</select>' +
                            '</div>' +

                            '<input type="hidden" name="gtm_upgrade_value">' +
                            '<div class="text-align-center">' +
                                '<button type="submit" class="primary account-payment-submit full margin-top-12">Upgrade my plan</button>' +
                            '</div>' +
                        '</form>' +
                    '</div>' :

                    '<div class="text-align-center">' +
                        '<hr>' +
                        '<button class="primary change-plan full">Update Subscription</button>' +
                    '</div>') +
                '</div>' +

                (this.plan_type === Constants.PLAN_2025_FREE ? '' :
                '<div class="text-align-center margin-top-30">' +
                    '<div class="font-weight-medium text-success"><i class="fad fa-shield-check"></i> Secure credit card payment</div>' +
                    '<div class="info margin-top-4">This is a secure 128-bit SSL encrypted payment</div>' +
                '</div>') +
            '</div>') +
        '</div>';

        this.$el.html(content);

        this.updatePrice();
        this.updateFeatrueLoss();

        var form = this.$el.find('form.payment');
        Form.setData(form, {
            country: Cache.account.get('country'),
            address: Cache.account.get('address')
        });

        // change plan has no form
        if (form.length) {
            // wait for the view to be rendered
            setTimeout(function() {
                window.jQuery = $;
                var card = new Card({
                    debug: false,
                    form: form.get(0),
                    container: '.card-wrapper',
                    formatting: true
                });
            }, 100);
        }

        // wait for the view to be rendered
        setTimeout(function() {
            Button.maskNumberInput();
        }, 100);

        return this;
    }
});